import React from "react";
import { MaterialReactTable } from "material-react-table";
import { NotificationManager } from "react-notifications";
import * as API from "../api/index";
import { useDataView } from "../../contexts/data.view.context";
import { sharedTableProps } from "../shared/tableProps";
import AddToolbarLink from "../shared/AddToolbarLink";

const TaskScheduleViewTable = ({ data, mainColumns }) => {
  const { fetchTaskSchedulesFromAllEnv } = useDataView();

  const handleSaveRow = async ({ exitEditingMode, row, values }) => {
    data[row.index] = values;

    const payload = [
      {
        _schedule_id: values.schedule_id,
        schedule_interval: values.schedule_interval,
        schedule_count: values.schedule_count,
        schedule_cron: values.schedule_cron,
        schedule_state: values.schedule_state,
        schedule_type: values.schedule_type,
        schedule_cmd: values.schedule_cmd,
        schedule_group: values.schedule_group,
        parallel_execute: values.parallel_execute,
      },
    ];

    API.UpdateRecord("integrations/cfg/schedules", payload).then((response) => {
      if (response.code === 200) {
        fetchTaskSchedulesFromAllEnv();
        NotificationManager.success("Record Updated", "Query Schedule", 10000);
      } else {
        NotificationManager.error(response.message, "Failed!", 10000);
      }
    });

    exitEditingMode();
  };

  const handleRowEditCancel = () => {
    fetchTaskSchedulesFromAllEnv();
  };

  return (
    <MaterialReactTable
      {...sharedTableProps}
      columns={mainColumns}
      data={data}
      onEditingRowSave={handleSaveRow}
      onEditingRowCancel={handleRowEditCancel}
      initialState={{ density: "compact" }}
      muiTableContainerProps={{ sx: { maxHeight: "600px" } }}
      renderTopToolbarCustomActions={() => (
        <AddToolbarLink to="/AddQuerySchedule" label="Add Schedule" />
      )}
    />
  );
};

export default TaskScheduleViewTable;
